var _defs, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 366.34 366.34",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2a196;}.cls-2{fill:#e88870;}.cls-3{fill:#ff2609;}.cls-4{fill:#845161;}.cls-5{fill:#69303a;}.cls-6{fill:#00214e;}.cls-7{fill:none;stroke:#00214e;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboards_Diversity_Avatars_by_Netguru") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.41,291.18a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38a46.35,46.35,0,0,0,12.78-15.09,44.69,44.69,0,0,0,4.64-14.48,67.91,67.91,0,0,0,.74-9.91c0-3.46-.09-6.92-.21-10.38-.07-2.26-.13-4.53-.16-6.79q-.06-4.75-.1-9.51l2,1,5.2,2.69,2.41.41,27.88,4.74,31.12,5.3.94,32,.31,10.46.15,5.08V258l1,.42,11.07,4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.82,258c-3.7.43-10-1-13.48-2.89-13-7.18-19.49-13-26.38-18.08-8.2-6.06-29.8-25.5-29.8-25.5-.07-2.26-.21-3.76-.24-6q-.06-4.75-.1-9.51l2,1,5.2,2.69,2.41.41,27.88,4.74,31.12,5.3.94,32,.31,10.46.15,5.08V258Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M296.41,291.18a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38,23.55,16.76,55.69,27.33,83.49,14.82,6.62-3,12.7-7.84,16.3-14.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.51,90.9c-.09.59-.2,1.17-.33,1.75a32.08,32.08,0,0,1-3.31,8.49l-.08.14c-.57,1-1.18,2-1.84,3a74.32,74.32,0,0,1-5.72,7.35L266,113c-.83.93-1.67,1.84-2.51,2.74,4.45-1,8.76,3.15,9.55,7.63s-1,9-3.21,13c-3.87,7.08-9.45,11.79-14.36,17.94-3.68,4.58-5.72,10-9.73,14.38l-.3.33c-10.59,11.12-27.31,13.72-41.23,18.47-5,1.72-59.22,17.12-59.22,20.48,0-.73-5.31-6-12-12.41-24-22.79-31.89-58-17.61-88.2,15.35-32.5,50.21-55.69,83.41-66.83,10.38-3.48,22.16-5.82,32-1s14.74,19.77,6.58,27.07a26.16,26.16,0,0,1,17.93-5.21,24.46,24.46,0,0,1,15.72,7.07,27,27,0,0,1,6.95,12.08A24.94,24.94,0,0,1,278.51,90.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.51,90.9c-.09.59-.2,1.17-.33,1.75-.09.17-.18.35-.27.55-1.13,2.58-1.65,5.36-3,7.94l-.08.14c-.57,1-1.18,2-1.84,3a67.09,67.09,0,0,1-5.72,7.35L266,113c-.83.93-1.67,1.84-2.51,2.74,4.45-1,8.76,3.15,9.55,7.63s-1,9-3.21,13c-3.87,7.08-9.45,11.79-14.36,17.94-3.68,4.58-5.72,10-9.73,14.38a37.7,37.7,0,0,1-8.54-19.47c-1.64-13.26-.64-27.71-1.09-41.13-.28-8.44-3-10,2.06-16.83a74.3,74.3,0,0,1,14-13.29c4.08-2.69,9.33-3.11,14.2-2.42a23.5,23.5,0,0,1,11.58,5A24.94,24.94,0,0,1,278.51,90.9Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.98,
    cy: 168,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 140.37,
    cy: 168,
    r: 15.22
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.6,152l4.38,55,66.44,40.88A19.77,19.77,0,0,0,236.1,238a267.38,267.38,0,0,0,13.14-31.88c2.64-7.84,5.22-15.89,5.47-24.23s-2.12-17-5-24.7c-.3-.81-1.9-3.3-1.76-4.15q1.67-10,3.32-19.94c1.26-7.51,2.87-15.35,1-22.9-2.13-8.66-8.67-12.35-14.05-18.82-14.16,18.24-37.44,28.55-57.77,39C170,135.78,140.6,152,140.6,152Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M251.07,200.5c-4.31,16.92-9.08,34.35-12.63,40.61-2.66,4.67-6.37,5.57-12.24,7a51.47,51.47,0,0,1-42.29-8.94l-39.09-31.48c-.6-5.89-1-6.79-1.29-12.71-.14-2.68-1-5.36-.36-8a6.9,6.9,0,0,0,1.7,3.73c4.73,6.42,10.25,13.67,18.11,16.31,8.2,2.75,17.53,3.18,25.45-.7,6.89-3.38,13.64-7.79,20.83-10.57a35.05,35.05,0,0,1,15.11-2.61c7.34.5,10.48,3.81,15.85,8.18,1.76,1.44,3.73,2.94,6,3C248.78,204.27,248.91,202.15,251.07,200.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189.72,149.8c6.1,0,6.1,9.38,0,9.43h-.28c-6.1,0-6.1-9.38,0-9.43h.28Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.84,148.41c5.67.05,5.67,8.7,0,8.75h-.25c-5.66,0-5.66-8.7,0-8.75h.25Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M215.13,147.09c-.08.35,13.36,36.13,13.36,36.13l-17.94.87"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M172.65,140.17a80.57,80.57,0,0,1,28.13-.79"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M231.7,140.28a55.34,55.34,0,0,1,17.45-1.21"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.52,203a28.12,28.12,0,0,0,17.4.32c.61-.19.35-1.16-.26-1a27.17,27.17,0,0,1-16.87-.31c-.61-.21-.87.75-.27,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar3);
export default __webpack_public_path__ + "static/media/avatar3.60a3dcfb5b53d0e54c25eba29653be92.svg";
export { ForwardRef as ReactComponent };